import React from "react";
import { useNavigate } from "react-router-dom";

import ExpandArrow from "./buttons/ExpandArrow";
import GameType from "../data/GameType";
import trashIcon from '../icons/trash.svg';
import pencilIcon from '../icons/pencil.svg';


const GameHeader = (props) => {
    const navigate = useNavigate();
    const openGame = (initialData) => {
        navigate(process.env.PUBLIC_URL + "/game/" + props.gameType.name + "?" + new URLSearchParams({initialData: initialData}));
    };
    const isBingo = () => {
        return props.gameType.name === GameType.BINGO.name;
    }
 

    return (
        <div className={`gameArea flexCenter marginTop1 marginLeft1 marginRight1 marginBottom1 ${props.isExpanded && props.rows.length > 0 ? "gameArea--expanded" : ""}`} >
            <img alt='' className='gameLogo' src={props.gameType.logo} onClick={() => openGame("empty") } ></img>
            {props.rows.length > 0 &&
                <div className='flexEnd flex'>
                    {isBingo() && !props.isFinal && <img alt='' className='icon editGame' src={trashIcon} onClick={props.deleteGame}></img>
                    }
                    {isBingo() && !props.isFinal && !props.isOpen && <img alt='' className='icon editGame' src={pencilIcon} onClick={props.onEdit}></img>}
                    {!props.isOpen &&  <div className="darkBlueBold15">{props.calculatePrice()}</div>}
                    {!isBingo() && !props.isFinal && <ExpandArrow isExpanded={props.isExpanded} className='marginLeft1' onToggleExpanded={props.onToggleExpanded}></ExpandArrow>}
                </div>
            }
        </div>
    );
};

export default GameHeader;